import { Flex, Td, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

function EditableTableCell(props) {
  const { value } = props;

  const editCell = (
    <Td textAlign='center' padding={0} color='#3483be' fontWeight={500}>
      <Flex direction='row' align='center' justify='center'>
        <Text whiteSpace='nowrap' overflowX='auto' className='custom-scrollbar'>{value}</Text>
      </Flex>
    </Td>
  );

  return editCell;
}

EditableTableCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number, PropTypes.array])
};

export default EditableTableCell;
